import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=64f77e0d&scoped=true&"
import script from "./ChatForm.ts?vue&type=script&lang=ts&"
export * from "./ChatForm.ts?vue&type=script&lang=ts&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=64f77e0d&lang=vue-scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f77e0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f77e0d')) {
      api.createRecord('64f77e0d', component.options)
    } else {
      api.reload('64f77e0d', component.options)
    }
    module.hot.accept("./ChatForm.vue?vue&type=template&id=64f77e0d&scoped=true&", function () {
      api.rerender('64f77e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/ChatBox/Components/ChatForm.vue"
export default component.exports